import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  Autocomplete,
  Stack,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/system";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import apiClient from "../utlis/apiClient";
import { Backdrop, CircularProgress } from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../Common/TableCss"
import { WindowSharp } from "@mui/icons-material";

const initalFormData = {
  SNO: { value: "", type: "text" },
  ProjectNumber: { value: "", type: "text" },
  Description: { value: "", type: "text" },
  ItemCode: { value: "", type: "text" },
  Quantity: { value: "", type: "text" },
  WorkOrderId: { value: "", type: "text" },
  PODate:  { value: "", type: "date" }
};

const UpdateWorkOrder = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { OutSourcePK } = location.state || {};
  const [lineItemPK, setLineItemPK] = useState("");
  const [incrementValue, setIncrementValue] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [lineItems, setLineItems] = useState([]);
  const [outsource, setOutSource] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formDataLine, setFormDataLine] = useState(initalFormData);
  const [loading, setLoading] = useState(false);
  const [descriptionOptions, setDescriptionOptions] = useState([]);
  const [projectsName, setProjectsName] = useState([]);
  const [formData, setFormData] = useState({
    GatePass: "",
    VendorName: "",
    CustomerName: "",
    Issued_Date: "",
    Received_Date: "",
    Status: "",
    ReturnStatus: "",
    Comments: "",
  });

  const formatDateForInput = (date) => {
    if (!date) return ""; // Handle empty value
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  };


  const OutSourceId = encodeURIComponent(OutSourcePK); // Adjust this line

  // Fetch LineItems from API and display in table
  useEffect(() => {
    console.log("Out Source Id", OutSourceId);

    apiClient
      .get(
        `/api/in-out-source/Get-Line-Items-By-Work-Order?OutSourcePK=${OutSourceId}`
      )
      .then((response) => {
        console.log("Response from API:", response);
        if (response.data.success) {
          setLineItems(response.data.LineItems);
          setOutSource(response.data.OutSource);
          console.log("Fetched line items:", response.data.LineItems);
          console.log("Fetched OutSource:", response.data.OutSource);
          console.log(response.data.OutSource[0].GatePass);

          // Update formData with OutSource values
          setFormData({
            GatePass: response.data.OutSource[0].GatePass || "",
            VendorName: response.data.OutSource[0]?.VendorName || "",
            CustomerName: response.data.OutSource[0]?.CustomerName || "",
            Issued_Date: formatDateForInput(response.data.OutSource[0]?.Issued_Date) || "",
            Received_Date: formatDateForInput(response.data.OutSource[0]?.Received_Date) || "",
            Status: response.data.OutSource[0]?.Status || "",
            ReturnStatus: response.data.OutSource[0]?.ReturnStatus || "",
            Comments: response.data.OutSource[0]?.Comments || "" ,
          });

          console.log("Form data:", formData);
        } else {
          console.error("Failed to fetch line items:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the line items!", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
          console.error("Response status:", error.response.status);
          console.error("Response headers:", error.response.headers);
        }
      });
  }, [OutSourceId]);



// Reusable function to generate and download the PDF
const generateAndDownloadPDF = async (formattedData) => {
  try {
    const pdfResponse = await axios.post(
      "https://q3cyoq1992.execute-api.ap-south-1.amazonaws.com/Prod/api/work.order/work-order-pdf",
      JSON.stringify(formattedData, null, 2),
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (pdfResponse.data) {
      const base64Pdf = pdfResponse.data; // Access the base64-encoded PDF data

      // Convert the base64 string to a Blob
      const byteCharacters = atob(base64Pdf); // Decode base64 to binary string
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Create a Blob from the byte array
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob); // Create a URL for the Blob

      // Trigger download
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = formattedData.GatePass || "WorkOrder.pdf"; // Set the desired filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the Blob URL
      URL.revokeObjectURL(blobUrl);
    } else {
      console.error("Failed to generate PDF");
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert("Failed to generate PDF. Please try again.");
  }
};

// Updated handleSaveClick with PDF integration
const handleSaveClick = async () => {
  setLoading(true); // Start loading

  try {
    const { Name, Values } = formData;

    console.log("Form Data:", formData);
    console.log("Current lineItems:", sortedLineItems);

    // Format line_items data
    const List_Item = sortedLineItems.map((row) => ({
      SNO: row.SNO,
      Description: row.Description,
      ProjectNumber: row.ProjectNumber,
      ItemCode: row.ItemCode,
      Quantity: row.Quantity,
      WorkOrderId: row.WorkOrderId,
      PODate: row.PODate,
    }));

    // Formatted data for PDF
    const formattedData = {
      GatePass: formData.GatePass,
      VendorName: formData.VendorName,
      CustomerName: formData.CustomerName,
      ReturnStatus: formData.ReturnStatus,
      Issued_Date: formData.Issued_Date,
      Received_Date: formData.Received_Date,
      Comments: formData.Comments,
      listItems: List_Item,
    };

    console.log("Formatted Data for Submission:", JSON.stringify(formattedData, null, 2));

    // Generate and download the PDF
    await generateAndDownloadPDF(formattedData);

    // Request body for API call
    const requestBody = {
      GatePass: formData.GatePass,
      VendorName: formData.VendorName,
      CustomerName: formData.CustomerName,
      Received_Date: formData.Received_Date,
      Status: formData.Status,
      Issued_Date: formData.Issued_Date,
      ReturnStatus: formData.ReturnStatus,
      WorkOrderPK: OutSourcePK,
      Comments: formData.Comments,
    };

    console.log("OutSource", OutSourceId);
    console.log("Sending request with body:", JSON.stringify(requestBody, null, 2));

    const token = sessionStorage.getItem("authToken");

    // API call to update data
    const response = await apiClient.post(
      `/api/in-out-source/In-House-Update`,
      requestBody
    );

    console.log("Full Response:", response);
    if (response.data && response.data.message) {
      console.log("In Source updated successfully");
      setIsEditing(false);
      alert("Updated the Work Order Successfully");
    } else {
      console.error("Update failed:", response.data.message || "Unknown error");
    }
    window.location.reload();
  } catch (error) {
    console.error("There was an error updating the project!", error);
    if (error.response) {
      console.error("Error response:", error.response.data);
    } else {
      console.error("Error message:", error.message);
    }
  } finally {
    setLoading(false); // End loading
  }
};


  const handleEditClick = () => {
    setIsEditing((prev) => !prev); // Toggle edit mode
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prevData) => {
      let updatedGatePass = prevData.GatePass;
  
      // Check if the field being changed is 'Status'
      if (name === "Status") {
        if (value === "In Source") {
          // Extract the number after 'G/' in GatePass
          const gatePassNumberMatch = updatedGatePass.match(/G\/(\d+)/);
          const number = gatePassNumberMatch ? gatePassNumberMatch[1] : ''; // Get the number after 'G/'
  
          // Append /R and the extracted number (if exists)
          updatedGatePass = `${updatedGatePass}/R${number ? number : ''}`;
        } else if (value === "Out Source") {
          // Remove any /R from GatePass
          updatedGatePass = updatedGatePass.replace(/\/R\d*/, "");
        }
      }
  
      return {
        ...prevData,
        [name]: value,
        GatePass: name === "Status" ? updatedGatePass : prevData.GatePass,
      };
    });
  };
  

  const fetchData = async () => {
    try {
      // Fetch products
      const projectResponse = await apiClient.get(
        `/api/project/get-all-projects`
      );

      // console.log("Projects:", projectResponse.data);

      if (Array.isArray(projectResponse.data.data)) {
        setProjectsName(projectResponse.data.data);
      } else {
        console.error(
          "Unexpected data format for products:",
          projectResponse.data.data
        );
        setProjectsName([]);
      }
    } catch (error) {
      console.error("Error fetching Project Details: ", error);
      setProjectsName([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRowClick = (item, index) => {
    setSelectedItem(item);
    setLineItemPK(item.PK);
  
    const updatedFormDataLine = {};
    Object.keys(initalFormData).forEach((key) => {
      let value = item[key] || "";
  
      // Format PODate to YYYY-MM-DD if it exists and matches DD/MM/YYYY format
      // if (key === "PODate" && value) {
      //   const [day, month, year] = value.split("/"); // Split DD/MM/YYYY
      //   value = `${day}-${month}-${year}`; // Convert to YYYY-MM-DD
      // }
  
      updatedFormDataLine[key] = {
        value: value,
        type: initalFormData[key]?.type || "text", // Default type to "text"
      };
    });

  
    // Example for explicitly setting additional fields
    updatedFormDataLine["ProjectNumber"] = {
      value: item.ProjectNumber || "",
      type: "text",
    };
  
    updatedFormDataLine["Description"] = {
      value: item.Description || "",
      type: "text",
    };

    updatedFormDataLine["SNO"] = {
      value: index + 1,
      type: "text",
    };
  
    setFormDataLine(updatedFormDataLine);
    setOpenDialog(true);
  };
  

  const handleAddRow = async () => {

    const PK = decodeURIComponent(OutSourceId)
    // Construct the data object based on formDataLine
    const updatedLineItem = {
      SNO: formDataLine["SNO"]?.value || "",
      ProjectNumber: formDataLine["ProjectNumber"]?.value || "",
      Description: formDataLine["Description"]?.value || "",
      Quantity: formDataLine["Quantity"]?.value || "",
      WorkOrderId: formDataLine["WorkOrderId"]?.value || "",
      ItemCode: formDataLine["ItemCode"]?.value || "",
      PODate: formDataLine["PODate"]?.value || "",
      workOrderPK: PK,
      woLineItemId: lineItemPK,
    };
  
    console.log(updatedLineItem);
  
    try {
      const token = sessionStorage.getItem("authToken");
  
      const response = await apiClient.post(
        `/api/in-out-source/update-lineitem`,
        updatedLineItem,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      console.log("Response from API:", response);
  
      if (response.data.message === "LineItem updated successfully") {
        const updatedData = response.data.updatedData;
  
        // Update lineItems in state
        setLineItems((prevLineItems) =>
          prevLineItems.map((item) =>
            item.PK === lineItemPK
              ? {
                  ...item,
                  Values: {
                    ...item.Values,
                    ...updatedData, // Directly update using updatedData
                  },
                }
              : item
          )
        );
  
        // Update formDataLine with the new data
        const updatedFormDataLine = {};
        Object.keys(initalFormData).forEach((key) => {
          updatedFormDataLine[key] = {
            value: updatedData[key] || "", // Safely access updatedData
            type: initalFormData[key]?.type || "text", 
          };
        });

        updatedFormDataLine["SNO"] = {
          value: lineItems.length + 1, 
          type: "text",
        };
  
        setFormDataLine(updatedFormDataLine); // Update form data for the dialog

        window.location.reload();
      } else {
        alert("Failed to update line item: " + response.data.message); // Alert on failure
      }
      
    } catch (error) {
      console.error("Error submitting line item:", error);
      // Handle the error (e.g., show a notification)
    } finally {
      // Close the dialog after submission
      handleCloseDialog();
    }
  };
  
  

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedItem(null); // Clear the selected item when dialog is closed
  };

  const handleTableChange = (event) => {
    const { name, value } = event.target;
  
    // Update form data
    setFormDataLine((prevState) => {
      const updatedFormData = {
        ...prevState,
        [name]: {
          ...prevState[name],
          value: value,
        },
      };
  
      return updatedFormData;
    });
  
    // Perform specific actions based on the name of the field
    if (name === "ProjectNumber" && value) {
      ProjectLineItem(value);
    } 
  
    if (name === "Description") {
      const selectedDescription = descriptionOptions.find(
        (option) => option.label === value
      );
  
      if (selectedDescription) {
        setFormDataLine((prevState) => ({
          ...prevState,
          Description: {
            ...prevState.Description,
            value: value,
          },
        }));
  
        // Fetch additional data by Description PK
        ProjectLineItemById(selectedDescription.pk);
      } else {
        // Clear the PK if the entered description is not found
        setFormDataLine((prevState) => ({
          ...prevState,
          Description: {
            ...prevState.Description,
            value: value,
            pk: "",
          },
        }));
      }
    }
  };

  const ProjectLineItem = async (ProjectNumber) => {
    // console.log(ProjectNumber);

    try {
      const projectResponse = await apiClient.get(
        `/api/line-item/get-lineitems-by-projectnumber`,
        {
          params: { ProjectNumber },
        }
      );

    //  console.log("Full Response:", projectResponse.data);

      // Check if the response contains LineItems
      if (projectResponse.data.success && projectResponse.data.LineItems) {
        const descriptionOptions = projectResponse.data.LineItems.map(
          (item) => ({
            label: item.Values.Description,
            pk: item.PK,
          })
        );
        setDescriptionOptions(descriptionOptions); 
      } else {
        console.error("No line items found in the response.");
        setDescriptionOptions([]); // Reset if no line items found
      }
    } catch (error) {
      console.error("Error fetching line items:", error);
      setDescriptionOptions([]); // Reset on error
    }
  };

  // GET THE ITEMS BY THE LINE
  const ProjectLineItemById = async (projectLinePK) => {
    const projectLinePKs = encodeURIComponent(projectLinePK);

    // console.log(projectLinePKs,": the link from des")

    try {
      const projectResponse = await apiClient.get(
        `/api/line-item/get-line-item-by-id/${projectLinePKs}`
      );

      const lineItem = projectResponse.data.data[0];

      console.log(lineItem.SK," the data");

      const PK = lineItem.SK;

      const projectId = encodeURIComponent(PK)

      const response = await apiClient.get(
        `/api/project/get-project-by-id/${projectId}`
      );

      console.log(response.data.data[0].Values?.ProjectDeliverydate);


      

      if (lineItem) {
        const { Values } = lineItem;

        setFormDataLine((prevState) => ({
          ...prevState,
          WorkOrderId: {
            ...prevState.WorkOrderId,
            value: Values?.WorkOrderId || "",
          },
          Quantity: {
            ...prevState.Quantity,
            value: Values?.QTYSETS || "",
          },
          Description: {
            ...prevState.Description,
            value: Values?.Description || "",
          },
          ItemCode: {
            ...prevState.ItemCode,
            value: Values?.ItemCode || "",
          },
          PODate: {
            ...prevState.ItemCode,
            value: response.data.data[0].Values?.ProjectDeliverydate || "",
          }
        }));
      }

      
    } catch (error) {
      console.error("Error fetching line items:", error);
    }
  };

     // Open dialog
     const handleClickOpen = () => {
      setOpen(true);
    };
  
    // Close dialog
    const handleClose = () => {
      setOpen(false);
      setFormDataLine(initalFormData); // Reset form data when closing
    };

    const handleSubmitLineItem = async (e) => {
      e.preventDefault();
  
      // Extract only the values from formDataLine
      const newLineItem = {
        ...Object.fromEntries(
          Object.entries(formDataLine).map(([key, obj]) => [key, obj.value])
        ),
        WorkOrderPK: OutSourcePK, 
      };
  
      // Log the data in JSON format
      console.log(
        JSON.stringify(newLineItem),
        ": JSON formatted data for single entry"
      );
  
      try {
        // const token = sessionStorage.getItem("authToken");
  
        const response = await apiClient.post(
          `/api/in-out-source/add-lineitem`,
          newLineItem,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
    
        console.log("Response from API:", response);
  
        // Reset formDataLine to its initial state (clear form)
        setFormDataLine(initalFormData);
        handleClose(); // Close dialog after successful submission
  
         window.location.reload();
      } catch (error) {
        if (error.response) {
          console.error("Error during form submission:", error.response.data);
        } else if (error.request) {
          console.error("No response received:", error.request);
        } else {
          console.error("Error:", error.message);
        }
      }
    };

  const sortedLineItems = [...lineItems].sort((a,b) =>  a.SNO - b.SNO);

  useEffect(() => {
    if (open) {
      // Calculate the highest SNO value and increment it by 1
      const highestSNO =
        lineItems.length > 0
          ? Math.max(...lineItems.map((_, index) => index + 1))
          : 0;
      const newSNO = highestSNO + 1;

      // Initialize formData with the incremented SNO value
      setFormDataLine({
        ...formDataLine,
        SNO: { value: newSNO.toString(), type: "text" },
      });
    }
  }, [open, lineItems]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Header />
      <SubHeader />

      <Grid
        container
        sx={{ flexGrow: 1, marginTop: "-80px", padding: 0 }}
        spacing={6}
      >
        <Grid item xs={12} md={2}>
          <Box
            sx={{
              height: "calc(100vh - 112px)", // Adjusted height based on Header + SubHeader
              backgroundColor: "white",
              borderRadius: "10px", // Adds border radius
              //  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Adds shadow
              marginLeft: "15px",
              display: "flex",
              flexDirection: "column", // Stack items vertically
              alignItems: "center", // Center items horizontally
            }}
          ></Box>
        </Grid>

        <Grid item xs={12} md={9}>
          <Box
            sx={{
              minHeight: "calc(100vh - 112px)",
              backgroundColor: "white",
              padding: 2, // Adding padding for the form
              borderRadius: "10px", // Adds border radius
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Adds shadow
              marginLeft: "-60px",
            }}
          >
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
            >
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  Work Order Details
                </Typography>
              </Grid>
              <Grid item>
                <Grid container spacing={2}>
                  <Grid item>
                    <Button
                      variant="text"
                      sx={{ width: "5px !important", height: "30px" }}
                      onClick={handleEditClick}
                    >
                      <EditOutlinedIcon />
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button
                      variant="contained"
                      sx={{ width: "50px", height: "30px" }}
                      onClick={handleSaveClick}
                      disabled={!isEditing} // Disable save button if not in edit mode
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <form noValidate autoComplete="off">
              <Grid container spacing={2}>
                {/* First Column */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="subtitle1"
                        sx={{ marginRight: "5px", fontSize: "12px" }}
                      >
                        Gate Pass:
                      </Typography>
                      <TextField
                        id="Gatepass"
                        name="Gatepass"
                        type="text"
                        value={formData.GatePass}
                        onChange={handleChange}
                        variant="standard"
                        InputProps={{
                          style: {
                            height: "auto", // Set height to auto
                            width: 150,
                            padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            fontSize: "14px", // Adjust font size
                          },
                          sx: {
                            minHeight: "unset", // Remove any default min-height
                            "& .MuiInputBase-input": {
                              padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            },
                          },
                        }}
                        InputLabelProps={{
                          shrink: true, // Ensure the label is always visible
                        }}
                        required
                        disabled={!isEditing} // Disable input if not in edit mode
                      />
                    </Box>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="subtitle1"
                        sx={{ marginRight: "5px", fontSize: "12px" }}
                      >
                        Vendor Name:
                      </Typography>
                      <TextField
                        name="VendorName" // Updated name to "CreationDate"
                        type="text"
                        value={formData.VendorName || ""}
                        onChange={handleChange}
                        variant="standard"
                        InputProps={{
                          style: {
                            height: "auto", // Set height to auto
                            width: 150,
                            padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            fontSize: "14px", // Adjust font size
                          },
                          sx: {
                            minHeight: "unset", // Remove any default min-height
                            "& .MuiInputBase-input": {
                              padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            },
                          },
                        }}
                        InputLabelProps={{
                          shrink: true, // Ensure the label is always visible
                        }}
                        required
                        disabled={!isEditing}
                      />
                    </Box>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="subtitle1"
                        sx={{ marginRight: "5px", fontSize: "12px" }}
                      >
                        Customer Name:
                      </Typography>
                      <TextField
                        name="VendorName" // Updated name to "CreationDate"
                        type="text"
                        value={formData.CustomerName || ""}
                        onChange={handleChange}
                        variant="standard"
                        InputProps={{
                          style: {
                            height: "auto", // Set height to auto
                            width: 150,
                            padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            fontSize: "14px", // Adjust font size
                          },
                          sx: {
                            minHeight: "unset", // Remove any default min-height
                            "& .MuiInputBase-input": {
                              padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            },
                          },
                        }}
                        InputLabelProps={{
                          shrink: true, // Ensure the label is always visible
                        }}
                        required
                        disabled={!isEditing}
                      />
                    </Box>
                  </FormControl>
                </Grid>

                {/* Second Column */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="subtitle1"
                        sx={{ marginRight: 1, fontSize: "12px" }}
                      >
                        Issued Date:
                      </Typography>
                      <TextField
                        id="Issued_Date"
                        name="Issued_Date"
                        type="date"
                        variant="standard"
                        value={formData.Issued_Date}
                        onChange={handleChange}
                        InputProps={{
                          style: {
                            height: "auto", // Set height to auto
                            width: 150,
                            padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            fontSize: "14px", // Adjust font size
                          },
                          sx: {
                            minHeight: "unset", // Remove any default min-height
                            "& .MuiInputBase-input": {
                              padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            },
                          },
                        }}
                        InputLabelProps={{
                          shrink: true, // Ensure the label is always visible
                        }}
                        required
                        disabled={!isEditing}
                      />
                    </Box>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="subtitle1"
                        sx={{ marginRight: 1, fontSize: "12px" }}
                      >
                        Received Date:
                      </Typography>
                      <TextField
                        id="Received_Date"
                        name="Received_Date"
                        type="date"
                        variant="standard"
                        value={formData.Received_Date}
                        onChange={handleChange}
                        InputProps={{
                          style: {
                            height: "auto", // Set height to auto
                            width: 150,
                            padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            fontSize: "14px", // Adjust font size
                          },
                          sx: {
                            minHeight: "unset", // Remove any default min-height
                            "& .MuiInputBase-input": {
                              padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            },
                          },
                        }}
                        InputLabelProps={{
                          shrink: true, // Ensure the label is always visible
                        }}
                        required
                        disabled={!isEditing}
                      />
                    </Box>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="subtitle1"
                        sx={{ marginRight: 1, fontSize: "12px" }}
                      >
                        Return Status:
                      </Typography>
                      <Select
                        id="ReturnStatus"
                        name="ReturnStatus"
                        value={formData.ReturnStatus}
                        onChange={handleChange}
                        variant="standard"
                        sx={{
                          minHeight: "unset", // Remove any default min-height
                          fontSize: "14px", // Adjust font size
                          width: 150,
                          padding: "0px 0px",
                        }}
                        disabled={!isEditing}
                        required
                        displayEmpty
                        inputProps={{
                          style: {
                            padding: "0px 0px",
                          },
                        }}
                      >
                        <MenuItem value="RETURNABLE GATEPASS">RETURNABLE GATEPASS</MenuItem>
                        <MenuItem value="NON RETURNABLE GATEPASS">
                          NON RETURNABLE GATEPASS
                        </MenuItem>
                      </Select>
                    </Box>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="subtitle1"
                        sx={{ marginRight: 1, fontSize: "12px" }}
                      >
                        Status:
                      </Typography>
                      <Select
                        id="Status"
                        name="Status"
                        value={formData.Status}
                        onChange={handleChange}
                        variant="standard"
                        sx={{
                          minHeight: "unset", // Remove any default min-height
                          "& .MuiInputBase-input": {
                            padding: "0px 0px", // Adjust padding (top-bottom right-left)
                          },
                        }}
                        disabled={!isEditing}
                        required
                        displayEmpty
                        inputProps={{
                          style: {
                            height: "auto", // Set height to auto
                            width: 150,
                            padding: "0px 0px", // Adjust padding (top-bottom right-left)
                            fontSize: "14px", // Adjust font size
                          },
                        }}
                      >
                        <MenuItem value="Out Source">Out Source</MenuItem>
                        <MenuItem value="In Source">In Source</MenuItem>
                      </Select>
                    </Box>
                  </FormControl>
                </Grid>
              </Grid>
            </form>

            <br />

            <div>
            <Grid item xs={12}>
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClickOpen}
                    sx={{ height: "30px", fontSize: "0.8rem", padding: "8px 8px" , width: "10px" }}

                  >
                    Add
                  </Button>
                  <Dialog fullWidth
                    maxWidth="md" open={open} onClose={handleClose}>
                    <DialogTitle>Add New Item</DialogTitle>
                    <DialogContent>
                      <Grid container spacing={3}>
                      {Object.keys(initalFormData).map((key) => {
                            if (key === "ProjectNumber") {
                              return (
                                <Grid item xs={12} md={3} key={`ProjectNumber-${key}`}>
                                  <Stack spacing={4}>
                                  <Autocomplete
                                      id="projects-autocomplete"
                                      freeSolo
                                      options={projectsName.map((option) => option.Values.PONumber)}
                                      disableClearable
                                      value={formDataLine.ProjectNumber?.value || ""}
                                      onChange={(event, newValue) => {
                                        handleTableChange({
                                          target: { name: "ProjectNumber", value: newValue },
                                        });
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Project Number"
                                          variant="standard"
                                          
                                          // onChange={handleTableChange}
                                          fullWidth
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          sx={{ mb: 1 }}
                                        />
                                      )}
                                      onInputChange={(event, newValue) => {
                                        handleTableChange({
                                          target: { name: "ProjectNumber", value: newValue },
                                        });
                                      }}
                                    />

                                  </Stack>
                                </Grid>
                              );
                            }

                            if (key === "Description") {
                              return (
                                <Grid item xs={12} md={3} key={`Description-${key}`}>
                                  <Stack spacing={4}>
                                  <Autocomplete
                                      id="description-autocomplete"
                                      freeSolo
                                      options={descriptionOptions.map((option) => option.label)}
                                      disableClearable
                                      value={formDataLine.Description?.value || ""}
                                      onChange={(event, newValue) => {
                                        handleTableChange({
                                        target: { name: "Description", value: newValue },
                                      });
                                    }}

                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Description"
                                          variant="standard"
                                         
                                         
                                          fullWidth
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          sx={{ mb: 1 }}
                                        />
                                      )}
                                      onInputChange={(event, newValue) => {
                                        handleTableChange({
                                          target: { name: "Description", value: newValue },
                                        });
                                      }}
                                    />

                                  </Stack>
                                </Grid>

                              );
                            }

                            return (
                              <Grid item xs={12} md={3} key={key}>
                                <TextField
                                  name={key}
                                  label={
                                    key === "SNO"
                                    ? "SNO"
                                    : key.replace(/([A-Z])/g, " $1").trim()
                                    }
                                  type={formDataLine[key]?.type || "text"}
                                  variant="standard"
                                  value={formDataLine[key]?.value || ""}
                                  onChange={(event) =>
                                    setFormDataLine((prevState) => ({
                                      ...prevState,
                                      [key]: {
                                        ...prevState[key],
                                        value: event.target.value,
                                      },
                                    }))
                                  }
                                  fullWidth
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  sx={{ mb: 1 }}
                                />
                              </Grid>
                            );
                          })}
                      </Grid>
                    </DialogContent>

                    <DialogActions>
                      <Button onClick={handleClose} color="secondary">
                        Cancel
                      </Button>
                      <Button onClick={handleSubmitLineItem} color="primary">
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>

                <TableContainer component={Paper} sx={{ marginTop: 4 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>SNO</StyledTableCell>
                    <StyledTableCell> Project Number</StyledTableCell>
                    <StyledTableCell> Description</StyledTableCell>
                    <StyledTableCell> Item Code</StyledTableCell>
                    <StyledTableCell>Quantity</StyledTableCell>
                    <StyledTableCell>Work Order Id</StyledTableCell>
                    <StyledTableCell>PO Date</StyledTableCell>
                    {/* <StyledTableCell>Action</StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedLineItems.map((item, index) => (
                    <TableRow key={item.PK}>
                      <StyledTableCell
                          onClick={() => handleRowClick(item, index)}
                         style={{
                              cursor: "pointer",
                            }}
                      >
                      {item.SNO}
                      </StyledTableCell>
                      <StyledTableCell
                       onClick={() => handleRowClick(item, index)}
                         style={{
                              cursor: "pointer",
                            }}
                      >{item.ProjectNumber}</StyledTableCell>
                      <StyledTableCell
                        onClick={() => handleRowClick(item, index)}
                         style={{
                              cursor: "pointer",
                            }}
                      >{item.Description}</StyledTableCell>
                      <StyledTableCell
                         onClick={() => handleRowClick(item, index)}
                         style={{
                              cursor: "pointer",
                            }}
                      >{item.ItemCode}</StyledTableCell>
                      <StyledTableCell
                         onClick={() => handleRowClick(item, index)}
                         style={{
                              cursor: "pointer",
                            }}
                      >{item.Quantity}</StyledTableCell>
                      <StyledTableCell
                         onClick={() => handleRowClick(item, index)}
                         style={{
                              cursor: "pointer",
                            }}
                      >{item.WorkOrderId}</StyledTableCell>
                      <StyledTableCell
                         onClick={() => handleRowClick(item, index)}
                         style={{
                              cursor: "pointer",
                            }}
                      >{item.PODate}</StyledTableCell>

                            {/* <StyledTableCell>
                              
                              <Button
                                color="secondary"
                                sx={{
                                  height: "20px",
                                  width: "53px",
                                  fontSize: "0.75rem",
                                }}
                                variant="contained"
                                //  onClick ={()=> handleRemoveRow(index)}
                             
                              >
                                Remove
                              </Button>
                            </StyledTableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

             {selectedItem && (
                  <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    fullWidth
                    maxWidth="md"
                  >
                    <DialogTitle>Edit Line Item</DialogTitle>
                    <br />
                    <DialogContent>
                      <Grid container spacing={3}>
                      {Object.keys(initalFormData).map((key) => {
                            if (key === "ProjectNumber") {
                              return (
                                <Grid item xs={12} md={3} key={key}>
                                  <Stack spacing={4}>
                                  <Autocomplete
                                      id="projects-autocomplete"
                                      freeSolo
                                      options={projectsName.map((option) => option.Values.PONumber)}
                                      disableClearable
                                      value={formDataLine.ProjectNumber?.value || ""}
                                      onChange={(event, newValue) => {
            handleTableChange({
              target: { name: "ProjectNumber", value: newValue },
            });
          }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Project Number"
                                          variant="standard"
                                          
                                          // onChange={handleTableChange}
                                          fullWidth
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          sx={{ mb: 1 }}
                                        />
                                      )}
                                      onInputChange={(event, newValue) => {
                                        handleTableChange({
                                          target: { name: "ProjectNumber", value: newValue },
                                        });
                                      }}
                                    />

                                  </Stack>
                                </Grid>
                              );
                            }

                            if (key === "Description") {
                              return (
                                <Grid item xs={12} md={3} key={key}>
                                  <Stack spacing={4}>
                                  <Autocomplete
                                      id="description-autocomplete"
                                      freeSolo
                                      options={descriptionOptions.map((option) => option.label)}
                                      disableClearable
                                      value={formDataLine.Description?.value || ""}
                                      onChange={(event, newValue) => {
                                      handleTableChange({
              target: { name: "Description", value: newValue },
            });
          }}

                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Description"
                                          variant="standard"
                                         
                                         
                                          fullWidth
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          sx={{ mb: 1 }}
                                        />
                                      )}
                                      onInputChange={(event, newValue) => {
                                        handleTableChange({
                                          target: { name: "Description", value: newValue },
                                        });
                                      }}
                                    />

                                  </Stack>
                                </Grid>

                              );
                            }

                            return (
                              <Grid item xs={12} md={3} key={key}>
                                <TextField
                                  name={key}
                                  label={
                                    key === "SNO"
                                    ? "SNO"
                                    : key.replace(/([A-Z])/g, " $1").trim()
                                    }
                                  type={formDataLine[key]?.type || "text"}
                                  variant="standard"
                                  value={formDataLine[key]?.value || ""}
                                  onChange={(event) =>
                                    setFormDataLine((prevState) => ({
                                      ...prevState,
                                      [key]: {
                                        ...prevState[key],
                                        value: event.target.value,
                                      },
                                    }))
                                  }
                                  fullWidth
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  sx={{ mb: 1 }}
                                />
                              </Grid>
                            );
                          })}
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseDialog}>Cancel</Button>
                      <Button onClick={handleAddRow}>Submit</Button>
                    </DialogActions>
                  </Dialog>
                )}
              </Grid>


            </div>

      
                <Grid item xs={12} sx={{mt:5}}>
                  <TextField
                    fullWidth
                    label="Comments"
                    name="Comments"
                    variant="outlined"
                    value={formData.Comments}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    multiline
                    rows={2}
                  />
                </Grid>
          </Box>
        </Grid>
      </Grid>
      <Backdrop
        open={loading}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: "#fff" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default UpdateWorkOrder;
